import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { observer } from 'mobx-react'
import { GeoJSON, LayerGroup } from 'react-leaflet'
import Icon from '../common/Icon'

// Renders a boundary which is being previewed in the
// boundary-listing UI
const icon = ReactDOMServer.renderToString(React.createElement(Icon, { extraClasses: ['item-list__icon'], id: 'hexagon' }))

const BoundaryLayer = ({ boundaryList, targetGroup }) => {
  const selectedBoundary = boundaryList && boundaryList.selectedBoundary
  const hasChildren = selectedBoundary && (
    selectedBoundary.hasChildren ||
    (selectedBoundary.boundaries && selectedBoundary.boundaries.length > 0)
  )

  // If boundary has children, VectorTileLayer renders the children vector tiles.
  // We only render GeoJSON for leaf boundaries to prevent covering and blocking clicks.
  if (hasChildren) return null

  return (
    <LayerGroup>
      {
        selectedBoundary && selectedBoundary.is_zip_code &&
        selectedBoundary.geoJSON
          ? (
            <GeoJSON
              key={selectedBoundary.id}
              data={selectedBoundary.geoJSON}
              onEachFeature={(feature, layer) => {
                const boundaryId = (feature && feature.properties && feature.properties.id) || selectedBoundary.id
                const boundaryName = (feature && feature.properties && feature.properties.name) || selectedBoundary.name
                layer.on('click', () => {
                  const selectedBoundaries = boundaryList.selectedBoundaries || []
                  const isSelected = selectedBoundaries.some(b => String(b.remote_db_id || b.id) === String(boundaryId))
                  if (isSelected) {
                    if (typeof boundaryList.removeBoundaryFromSelection === 'function') {
                      boundaryList.removeBoundaryFromSelection({ id: boundaryId })
                    }
                  } else {
                    if (typeof boundaryList.addBoundaryToSelection === 'function') {
                      boundaryList.addBoundaryToSelection({
                        id: boundaryId,
                        name: boundaryName,
                        targetGroupId: targetGroup ? targetGroup.pk : null,
                        ids: selectedBoundary.ids || [],
                        isZipCode: true
                      })
                    }
                  }
                })
                layer.bindPopup(`
                  <div class='geojson-tooltip-container'>
                    <div>${icon}</div>
                    <div>${boundaryName}</div>
                  </div>`, { className: 'geojson-tooltip' })
                layer.on('mouseover', () => layer.openPopup())
                layer.on('mouseout', () => layer.closePopup())
              }}
              smoothFactor={selectedBoundary.smoothFactor}
              className='region-buffer'
              style={
                {
                  color: 'blue',
                  weight: 3
                }
              }
              fillOpacity='0.6'
            />
            )
          : null
      }
    </LayerGroup>
  )
}

export default observer(BoundaryLayer)
